import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent, provideSvgIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';
import { LOCALE_ID_VALUE } from '@shared/utils/locales';

import { appCalendar24Icon } from '@icons/calendar-24';
import { appChevronDown16Icon } from '@icons/chevron-down-16';

import { DateInputComponent, DateRangeInputComponent } from './components';
import { DateAdapter, LuxonAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_LUXON_FORMATS, MatDatepickerModule } from './datepicker';
import { MatDateFormats } from './datepicker/core/datetime';

const icons = [appCalendar24Icon, appChevronDown16Icon];
const DATE_INPUT_LUXON_FORMATS: MatDateFormats = {
  parse: {
    dateInput: [MAT_LUXON_FORMATS.parse.dateInput],
    dateTimeInput: ['dd/MM/yyyy HH:mm'],
    monthYearInput: ['MM/yyyy'],
  },
  display: {
    dateInput: MAT_LUXON_FORMATS.display.dateInput,
    dateTimeInput: 'dd/MM/yyyy HH:mm',
    monthYearInput: 'MM/yyyy',
    monthYearLabel: MAT_LUXON_FORMATS.display.monthYearLabel,
    dateA11yLabel: MAT_LUXON_FORMATS.display.dateA11yLabel,
    monthYearA11yLabel: MAT_LUXON_FORMATS.display.monthYearA11yLabel,
  },
};

@NgModule({
  declarations: [DateRangeInputComponent, DateInputComponent],
  imports: [CommonModule, MatDatepickerModule, FormsModule, ReactiveFormsModule, TranslatePipe, SvgIconComponent, LoadingSkeletonComponent],
  exports: [DateRangeInputComponent, DateInputComponent],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: LOCALE_ID_VALUE },
    provideSvgIcons(icons),
    {
      provide: DateAdapter,
      useClass: LuxonAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: DATE_INPUT_LUXON_FORMATS },
  ],
})
export class DateInputModule {}
